import "@/App.css";
import { ThemeProvider } from "next-themes";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { AdminLeadsPage } from "@/pages/AdminLeadsPage";
import { AdminLoginPage } from "@/pages/AdminLoginPage";
import { SiteLayout } from "@/components/SiteLayout";
import { Toaster } from "@/components/ui/sonner";
import { ContactPage } from "@/pages/ContactPage";
import { CouncilsPage } from "@/pages/CouncilsPage";
import { FamiliesPage } from "@/pages/FamiliesPage";
import { HomePage } from "@/pages/HomePage";
import { PlatformPage } from "@/pages/PlatformPage";
import { SafeguardingPage } from "@/pages/SafeguardingPage";
import { SchoolsPage } from "@/pages/SchoolsPage";
import { ServicesPage } from "@/pages/ServicesPage";

function App() {
  return (
    <div className="App">
      <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
        <BrowserRouter>
          <Routes>
            <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/leads" element={<AdminLeadsPage />} />
            <Route path="/" element={<SiteLayout />}>
              <Route index element={<HomePage />} />
              <Route path="services" element={<ServicesPage />} />
              <Route path="platform" element={<PlatformPage />} />
              <Route path="procurement" element={<CouncilsPage />} />
              <Route path="councils" element={<CouncilsPage />} />
              <Route path="schools" element={<SchoolsPage />} />
              <Route path="families" element={<FamiliesPage />} />
              <Route path="safeguarding" element={<SafeguardingPage />} />
              <Route path="contact" element={<ContactPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </ThemeProvider>
    </div>
  );
}

export default App;
